export const transformPageNameForURL = (pageName) =>
  pageName?.toLowerCase().replaceAll(/\s/g, '-');

export const formatNewPageName = (pageName) =>
  pageName?.trim().replaceAll(/\s\s+/g, ' ');
